import { SearchBar as SearchBarComponent } from "@synthesis/shared-ui";
import { parseAsString, useQueryState } from "nuqs";
import type { ComponentProps } from "react";

type SearchBarProps = ComponentProps<typeof SearchBarComponent>;

export const SearchBar = (props: SearchBarProps) => {
  const [search, setSearch] = useSearch();

  return <SearchBarComponent {...props} onChange={setSearch} value={search} />;
};

const parser = parseAsString.withDefault("").withOptions({ clearOnDefault: true });
const useSearch = () => useQueryState("search", parser);
